import { Log } from './log';
import { ILogger, LogDeviceInformation } from './types';

export let logger: ILogger;

export const createLogger = (
    gatewayLoggingUrl: string,
    isProduction: boolean,
    logDeviceInformation: LogDeviceInformation,
    logRequestEnrich: (clone: Record<string, any>) => void
) => {
    logger = new Log(gatewayLoggingUrl, isProduction, logDeviceInformation, logRequestEnrich);
};

export const logInformation = (message: string, parameters?: object): void => {
    if (logger) {
        logger.information(message, parameters);
    } else {
        console.info(`no logger here; but message was:  ${message}, ${JSON.stringify(parameters)}`);
    }
};

export const logWarning = (message: string, parameters?: object): void => {
    if (logger) {
        logger.warning(message, parameters);
    } else {
        console.warn(`no logger here; but message was: ${message}, ${JSON.stringify(parameters)}`);
    }
};

export const logFatal = (message: string, parameters?: object): void => {
    if (logger) {
        logger.fatal(message, parameters);
    } else {
        console.error(`no logger here; but message was: ${message}, ${JSON.stringify(parameters)}`);
    }
};

export const logError = (message: string, parameters?: object): void => {
    if (logger) {
        logger.error(message, parameters);
    } else {
        console.error(`no logger here; but message was: ${message}, ${JSON.stringify(parameters)}`);
    }
};

export const logDebug = (message: string, parameters?: object): void => {
    if (logger) {
        logger.debug(message, parameters);
    } else {
        console.debug(`no logger here; but message was: ${message}, ${JSON.stringify(parameters)}`);
    }
};

export const logVerbose = (message: string, parameters?: object): void => {
    if (logger) {
        logger.verbose(message, parameters);
    } else {
        console.trace(`no logger here; but message was: ${message}, ${JSON.stringify(parameters)}`);
    }
};

export const errorHandler = (error: any, info: { componentStack: string }): void => {
    if (typeof error === 'object' && error !== null) {
        logError('ErrorBoundry {message}', { message: error.message, stack: error.stack, name: error.name, code: error.code, info });
    } else if (typeof error === 'function') {
        // `JSON.stringify()` discards functions. We do too, unless a function is thrown directly.
        logError('ErrorBoundry {message}', { message: `[Function: ${error.name || 'anonymous'}]`, info });
    } else {
        logError('ErrorBoundry {message}', { message: JSON.stringify(error), info });
    }
};
